import React from 'react';
import PropTypes from 'prop-types';

import { faFileCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from 'shared/button';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';
import { download } from 'components/file_system/helpers';

export default function NoPreview({ file }) {
  return (
    <Empty className="bg-white">
      <Empty.Media>
        <FontAwesomeIcon icon={faFileCircleExclamation} />
      </Empty.Media>
      <Empty.Title>This file can't be previewed</Empty.Title>
      <Empty.Content>Please click download to view</Empty.Content>
      <Empty.Actions>
        <Button.Primary label="Download" onClick={() => download(file)} />
      </Empty.Actions>
    </Empty>
  );
}

NoPreview.propTypes = {
  file: PropTypes.shape({
    downloadUrl: PropTypes.string,
    fileName: PropTypes.string,
    url: PropTypes.string
  })
};
